export const INTERNAL_ERROR = 0;
export const INSUFFICIENT_FUNDS = 1;
export const FACTORS_CHANGED = 2;
export const ACCOUNT_LOCKED = 3;
export const SYSTEM_NOT_ALLOWED_FOR_FREEBET = 4;

export const INCORRECT_STAKE = 5;
export const MIN_STAKE_AMOUNT = 6;
export const INCORRECT_VIRTUAL_STAKE = 7;
export const INCORRECT_FREEBET_STAKE = 8;
export const EXISTING_ACTIVE_STAKE = 9;
export const NO_BIG_STAKE_PERMISSION = 10;
export const FREEBET_BIG_STAKE = 11;
export const ALTERNATIVE_STAKE = 12;
export const NOT_POSSIBLE_STAKE = 13;

export const PromoCodeErrors = [-1,-2,-21, -22, -23, -24, -31, -32, -33, -34, -35, -36, -37, -38]


// WEBPACK FOOTER //
// ./js/constants/BetCreateErrorStatus.js